import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  Icon,
  UilChartPie,
  UilCube,
  UilFileContract,
  UilSetting
} from '@iconscout/react-unicons';

export interface Route {
  name: string;
  icon?: IconProp | string | string[];
  iconSet?: 'font-awesome' | 'feather' | 'unicons';
  pages?: Route[];
  path?: string;
  pathName?: string;
  flat?: boolean;
  topNavIcon?: string;
  dropdownInside?: boolean;
  active?: boolean;
  new?: boolean;
  hasNew?: boolean;
  isNext?: boolean;
}

export interface RouteItems {
  label: string;
  horizontalNavLabel?: string;
  icon: Icon;
  labelDisabled?: boolean;
  pages: Route[];
  megaMenu?: boolean;
  active?: boolean;
}

export const routes: RouteItems[] = [
  // {
  //   label: 'dashboard',
  //   horizontalNavLabel: 'Dashboard',
  //   active: true,
  //   icon: UilChartPie,
  //   labelDisabled: true,
  //   pages: [
  //     {
  //       name: 'Dashboard',
  //       icon: 'grid',
  //       flat: true,
  //       hasNew: true,
  //       path: '/',
  //       pathName: '/',
  //       active: true
  //     }
  //   ]
  // },
  {
    label: 'properties',
    horizontalNavLabel: 'properties',
    active: true,
    icon: UilChartPie,
    labelDisabled: true,
    pages: [
      {
        name: 'properties',
        path: '/dashboard/properties',
        pathName: 'properties',
        active: true,
        icon: 'home'
      }
    ]
  },
  // {
  //   label: 'contact',
  //   horizontalNavLabel: 'contact',
  //   active: true,
  //   icon: UilFileContract,
  //   labelDisabled: true,
  //   pages: [
  //     {
  //       name: 'contact',
  //       path: '/dashboard/contact',
  //       pathName: 'contact',
  //       active: true,
  //       icon: 'book'
  //     }
  //   ]
  // },
  {
    label: 'setting',
    horizontalNavLabel: 'settings',
    active: true,
    icon: UilSetting,
    labelDisabled: true,
    pages: [
      {
        name: 'settings',
        path: '/dashboard/settings',
        pathName: 'setting',
        active: true,
        icon: 'settings'
      }
    ]
  }
];
